import React from 'react';
import { IconProps } from '../../types/icons';
import './icon.scss';

const PlaneLandingIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className}`;

  return (
    <svg
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="planelandingicon"
      viewBox="0 0 100 125"
    >
      <path d="M80,83c0,1.657-1.342,3-3,3H23c-1.658,0-3-1.343-3-3s1.342-3,3-3h54C78.658,80,80,81.343,80,83z" fill={fill || '#7E8A96'} />
      <path d="M78.988,43.431l-13.659-3.862l-6.056-20.862c-1.263-4.351-4.793-7.687-9.206-8.705l-8.345-1.926  c-0.89-0.204-1.826,0.007-2.541,0.577c-0.717,0.568-1.134,1.432-1.133,2.347v20.849l-7.146-2.023l-1.762-8.808  c-0.238-1.187-1.166-2.115-2.353-2.353l-10.607-2.121c-0.835-0.168-1.702,0.028-2.382,0.539c-0.683,0.509-1.118,1.283-1.194,2.131  l-1.206,13.271c-0.658,7.26,3.634,14.145,10.442,16.75l48.957,18.73c7.181,2.764,15.184-1.336,17.147-8.777l0.007-0.028  C89.725,52.403,85.71,45.351,78.988,43.431z M82.143,57.64l-0.004,0.021c-1.053,3.994-5.327,6.19-9.196,4.701L23.981,43.628  c-4.309-1.649-7.028-6.011-6.608-10.602l0.903-9.944l5.373,1.074l1.729,8.646c0.221,1.105,1.043,1.99,2.125,2.299l12.728,3.6  c0.904,0.256,1.876,0.072,2.626-0.496c0.749-0.567,1.19-1.451,1.19-2.392V14.77l4.67,1.077c2.303,0.536,4.135,2.271,4.795,4.532  l6.057,20.865c0.582,1.999,2.129,3.531,4.128,4.097l13.652,3.861C80.949,50.225,83.1,54.011,82.143,57.64z" fill={fill || '#7E8A96'} />
    </svg>
  );
};

export default PlaneLandingIcon;
